import { cn } from "@/lib/utils";
import { ChevronRightIcon, HomeIcon } from "lucide-react";
import Link from "next/link";

type TVCBreadCrumbProps = {
	vcFirm?: {
		name?: string;
		slug?: string;
	};
	className?: string;
};

const VCBreadCrumb = ({ vcFirm, className }: TVCBreadCrumbProps) => {
	return (
		<div className={cn("flex items-center gap-1 py-2", className)}>
			<Link href="/" className="text-xxs text-gray-800 md:text-base flex items-center hover:underline hover:text-black">
				<HomeIcon className="h-3.5 w-3.5 stroke-gray-800 hover:stroke-black" />
			</Link>

			<span>
				<ChevronRightIcon className="h-3 w-3 text-gray-800" />
			</span>

			{vcFirm ? (
				<>
					<Link href="/vc" className="text-xxs whitespace-nowrap text-gray-800 uppercase font-semibold md:text-xs hover:underline hover:text-black">
						Vc Firms
					</Link>

					<span>
						<ChevronRightIcon className="h-3 w-3 text-gray-800" />
					</span>

					<span className="whitespace-nowrap text-xxs uppercase font-semibold text-gray-800 md:text-xs hover:underline hover:text-black">
						{vcFirm.name}
					</span>
				</>
			) : (
				<span className="text-xxs whitespace-nowrap text-gray-800 uppercase font-semibold md:text-xs hover:underline hover:text-black">
					Vc Firms
				</span>
			)}
		</div>
	);
};

export default VCBreadCrumb;
